import { useRecoilValue } from "recoil";
import { configState } from "base/store/config";

const useUser = () => {
  const { admin, user } = useRecoilValue(configState);

  if (!user) {
    return {};
  }

  return {
    isAdmin: admin,
    cn: user?.cn,
    email: user?.email,
    name: user?.name,
    no: user?.no,
  };
};

export default useUser;
